function fmtBytes(n) {
    if (!n || n < 1024) return `${n || 0} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    if (n < 1024 ** 3) return `${(n / 1024 / 1024).toFixed(1)} MB`;
    return `${(n / 1024 ** 3).toFixed(2)} GB`;
}

export default function StorageIndicator({ used, quota }) {
    const pct = quota ? Math.min(100, (used / quota) * 100) : 0;
    return (
        <div data-testid="storage-indicator" className="space-y-2">
            <div className="flex justify-between items-baseline gap-3">
                <span className="font-mono-tight text-[10px] uppercase tracking-[0.28em] text-tca-cyan/75">
                    // Storage
                </span>
                <span className="font-mono-tight text-[11px] text-tca-ink">
                    {fmtBytes(used)} <span className="text-tca-ink-muted">/ {fmtBytes(quota)}</span>
                </span>
            </div>
            <div className="h-1 bg-tca-ink-dim/40 rounded-full overflow-hidden">
                <div
                    className="h-full bg-gradient-to-r from-tca-cyan to-tca-cyan-hi"
                    style={{ width: `${pct}%`, transition: "width 0.5s ease" }}
                />
            </div>
        </div>
    );
}
